import { render, staticRenderFns } from "./NewsCategoryCreate.vue?vue&type=template&id=085827d8&lang=pug"
import script from "./NewsCategoryCreate.vue?vue&type=script&lang=js"
export * from "./NewsCategoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports